import React from "react";
import { Typography, Checkbox, Button } from "antd";
import { useState } from "react";
import { Row, Col } from "reactstrap";
import { useSelector } from "react-redux";
const { Paragraph, Text } = Typography;
const Step3_rules = (props) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const [disabled, setDisabled] = useState(true);
  const [data, setData] = useState(false);
  return (
    <div>
      <Paragraph
        ellipsis={{ rows: 5, expandable: true, symbol: lang_choiced.pages.add_fact.step3.more }}
        style={{ textAlign: "justify" }}
      >
       {
        lang_choiced.pages.add_fact.step3.policy_text.map(({text})=><Text>{text}</Text>)
       }
      </Paragraph>
      <Checkbox
        style={{ color: "red" }}
        onChange={(e) => {
          setDisabled(!e.target.checked);
        }}
      >
        {lang_choiced.pages.add_fact.step3.accept_policy}
      </Checkbox>
      <br />
      <Checkbox
        onChange={(e) => {
          setData(e.target.checked);
        }}
      >
         {lang_choiced.pages.add_fact.step3.show_data}
      </Checkbox>

      <Row className="mt-4">
        <Col className="text-right">
          <Button
            disabled={disabled}
            onClick={() => {
              props.validation(true);
              props.data({ showData: data }, "step4");
            }}
            type="primary"
          >
             {lang_choiced.pages.add_fact.btnNext}
          </Button>
        </Col>
        <Col className="text-left">
          <Button
            onClick={() => {
              props.back(true);
            }}
            danger
          >
            {lang_choiced.pages.add_fact.btnBack}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Step3_rules;
